import { render, staticRenderFns } from "./PostSroMainTableData.vue?vue&type=template&id=70f135ce"
import script from "./PostSroMainTableData.vue?vue&type=script&lang=js"
export * from "./PostSroMainTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports